import React from "react";
import PropTypes from "prop-types";
import createThemedStyles from "./createThemedStyles";
import ThemeContext, { themeNames, initialContextValue } from "./ThemeContext";

export default function provideTheme(Component, styles, themes) {
  function ThemeProviderWrapper({ theme: initialTheme, ...props }) {
    let name = initialTheme;

    if (typeof window !== "undefined" && window.GLOBAL_UI_INITIAL_PROPS) {
      name = window.GLOBAL_UI_INITIAL_PROPS.theme || name;
    }

    let themedStyles = {};

    if (styles && themes) {
      themedStyles = createThemedStyles(styles, themes[name]);
    }

    return (
      <ThemeContext.Provider value={name}>
        <Component {...props} theme={{ name, styles: themedStyles }} />
      </ThemeContext.Provider>
    );
  }

  ThemeProviderWrapper.propTypes = {
    theme: PropTypes.oneOf(themeNames),
  };

  ThemeProviderWrapper.defaultProps = {
    theme: initialContextValue,
  };

  return ThemeProviderWrapper;
}
